import { render, staticRenderFns } from "./ArtworkShare.vue?vue&type=template&id=01a0fdf5&scoped=true"
import script from "./ArtworkShare.vue?vue&type=script&lang=js"
export * from "./ArtworkShare.vue?vue&type=script&lang=js"
import style0 from "./ArtworkShare.vue?vue&type=style&index=0&id=01a0fdf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a0fdf5",
  null
  
)

export default component.exports